/**
 * Returns the dashboard path for a user based on their role.
 * Used to redirect logged-in users when they open the app or visit / or /login.
 */
export function getDashboardPath(user) {
  if (!user || !user.role) return '/';
  switch (user.role) {
    case 'superadmin':
      return '/superadmin';
    case 'restaurantadmin':
      return '/restaurant/menu';
    case 'staff': {
      const roleName = user.roleName || user.role?.name || '';
      if (typeof roleName === 'string' && (roleName === 'COOK' || roleName === 'Cook' || roleName === 'cook')) {
        return '/chef';
      }
      return '/waiter';
    }
    case 'customer':
      return '/customer';
    case 'companyemployee':
      return '/employee/dashboard';
    default:
      return '/restaurant/menu';
  }
}
